var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfabackbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#A8B2C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5677 14.8802L19.4537 18.942L18.2515 20.0122L19.4536 21.0852L24.5676 25.1442C24.8962 25.4057 25.0362 25.7965 24.9348 26.1695C24.8335 26.5427 24.5062 26.8414 24.0762 26.9533C23.6462 27.0651 23.1789 26.9729 22.8503 26.7117L15.3999 20.7958C15.1448 20.5933 15 20.3094 15 20.0122C15 19.715 15.1448 19.4312 15.3999 19.2286L22.8503 13.3156C23.0912 13.1095 23.4203 12.9955 23.7616 13.0001C24.103 13.0046 24.4277 13.1272 24.6609 13.3397C24.8941 13.5522 25.0161 13.8363 24.9983 14.1269C24.9807 14.4175 24.8252 14.6894 24.5677 14.8802Z",
    fill: "#7C8593"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfabackbutton);
export default __webpack_public_path__ + "static/media/mfabackbutton.967de9551ae5cb09636f5631bafcc254.svg";
export { ForwardRef as ReactComponent };